
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-comic-filter",
      function () {
        return require("private-next-pages/ai-comic-filter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-comic-filter"])
      });
    }
  